import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, customers } = useContext<ICustomersContext>(CustomersContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={customers.customerCount ? 800 : undefined}
		/>
	);
};

export default Search;
